import {AbstractModelContainer} from "../inputs/form/form.component";
import {QueryList} from "@angular/core";
import {NgModel} from "@angular/forms";

export enum IntegratedPaymentProvider {
    STRIPE = <any>"stripe",
    TYRO = <any>"tyro",
    OOLIO = <any>"oolio"
}

export enum PaymentType {
    GOOGLE_PAY = <any>"google pay",
    APPLE_PAY = <any>"apple pay",
    SAVED_CREDIT_CARD = <any>"saved credit card",
    NEW_CREDIT_CARD = <any>"new credit card",
    POINTS = <any>"points",
    NONE = <any>"none",
    GROUP_PAY = <any>"group pay"
}

export enum PaymentAuthorisationType {
    STRIPE_PAYMENT_METHOD = <any>"STRIPE_PAYMENT_METHOD",
    STRIPE_CARD_TOKEN = <any>"STRIPE_CARD_TOKEN",
    TYRO_PAYMENT_INTENT = <any>"TYRO_PAYMENT_INTENT",
    ADYEN_PAYMENT_METHOD = <any>"ADYEN_PAYMENT_METHOD"
}

export enum WalletProvider {
    APPLE_PAY = <any>"apple pay",
    GOOGLE_PAY = <any>"google pay"
}

export enum WalletPaymentErrorType {
    APPLE_PAY_CANCELLED,
    GOOGLE_PAY_CANCELLED,
    INVALID_STATE,
    PROVIDER_ERROR
}

export class WalletPaymentSubmissionResult {
    constructor(public authorisationType: PaymentAuthorisationType,
                public token?: string,
                public payerName?: string,
                public payerEmail?: string,
                public payerPhone?: string,
                public payerPostcode?: string) {
    }
}

export class WalletPaymentSubmissionFailure {
    // noinspection JSUnusedGlobalSymbols
    constructor(public errorType: WalletPaymentErrorType,
                public providerErrorType?: any,
                public providerErrorMessage?: string,
                public providerErrorCode?: string,
                public providerGatewayCode?: string) {
    }
}

export class CardPaymentSubmissionResult {
    constructor(public authorisationType: PaymentAuthorisationType,
                public token?: string,
                public brand?: string,
                public country?: string,
                public last4?: string) {
    }
}

export class CardPaymentSubmissionFailure {
    constructor(public errorMessage: string,
                public errorCode?: string,
                public gatewayCode?: string,
                public cardValidationFailure: boolean = false,
                public notifiable: boolean = true) {
    }
}

export abstract class PaymentCard extends AbstractModelContainer {
    abstract canSavePaymentDetails(): boolean;

    abstract isValid(): boolean;

    abstract markAsUnsubmitted(): void;

    abstract submit(): Promise<CardPaymentSubmissionResult | CardPaymentSubmissionFailure>;

    getModels(): QueryList<NgModel> {
        return undefined;
    }
}

export class ThreeDSResult {
    constructor(public success: boolean,
                public paymentIntent: string,
                public error?: any) {
    }
}


// WEBPACK FOOTER //
// ./src/app/payment/payment.ts